import { FC, ReactNode } from 'react';
import CardHeaderTemplate from './CardHeaderTemplate';
import { HeaderHeightKey } from '../types/CardTypes';

interface CardIconHeader {
  icon: ReactNode;
  title: string;
  subtitle?: string;
  headerHeight: HeaderHeightKey;
  withBorder?: boolean;
}

const CardIconHeader: FC<CardIconHeader> = ({
  icon,
  title,
  subtitle,
  headerHeight,
  withBorder = true,
}) => {
  return (
    <CardHeaderTemplate headerHeight={headerHeight} withBorder={withBorder}>
      <div className='flex flex-col flex-1 items-center justify-center'>
        <div className='mb-6'>{icon}</div>
        <h2 className='font-bold text-xl tracking-tight text-center mb-3 lg:text-2xl xl:text-2xl'>
          {title}
        </h2>
        {subtitle ? (
          <h3 className='font-medium text-sm text-gray-dark text-center lg:text-base xl:text-base'>
            {subtitle}
          </h3>
        ) : null}
      </div>
    </CardHeaderTemplate>
  );
};

export default CardIconHeader;
